import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Configurations from './ecoleConfig';
import EcoleConfigUpdate from './ecoleConfig-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleId`} component={Configurations} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleId/:configId/edit`} component={EcoleConfigUpdate} />
  </>
);

export default Routes;
